export default __webpack_public_path__ + "static/media/10a.dc5118c7.png";